import styled from 'styled-components';
import { LayoutItemType } from '../seatMapConstants';
import { Legend, SeatSchema, setWidthAndHeight } from './SeatMapStyled';

export const VerticalSeatMap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FakeVerticalSeatMapWrapper = styled.div`
  ${({ width, height }) => setWidthAndHeight(width, height)};
`;

export const SeatMapTransformWrapper = styled.div`
  position: absolute;

  transform: rotate(270deg);
  transform-origin: top left;
`;

export const VerticalSeatMapWrapper = styled.div`
  position: relative;

  ${({ width, height }) => setWidthAndHeight(width, height)};
`;

export const SeatVerticalSchema = styled(SeatSchema)`
  .seatId {
    transform: rotate(90deg);

    font-size: 14px;
  }

  [data-type=${LayoutItemType.STAIRS}],
  [data-type=${LayoutItemType.LUGGAGEROOM}],
  [data-type=${LayoutItemType.LUGGAGERACK}],
  [data-type=${LayoutItemType.BATHROOM}] {
    svg {
      transform: rotate(90deg);
    }
  }
`;

export const VerticalSeatMapDirection = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0 0 4px 0;
  margin-bottom: 8px;
  font-size: 10px;
  font-weight: 300;

  svg {
    margin-left: 8px;
    transform: rotate(270deg);
  }
`;

export const SeatMapVerticalLegend = styled(Legend)`
  justify-content: center;

  font-size: 10px;
`;
